import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    create_sso_users: false,
    showNewSummaryBar: false,
    isStyle2pt0: true,
    overrideAPI: "default",
    persist_settings: false,
    polling: true,
    run_sentry_localhost: false,
    showCredentialManagement_npt: false,
    showRealTimeAuths: false,
    showRevBoost_Experiments2: false,
    showRevBoost_retry: false,
    useTestApiHeader: false,
    viewInspector: false
};

const reducers = {
    /** @type {BooleanPayloadReducer} */
    PERSIST_SETTINGS: (state, { payload }) => ({ ...state, persist_settings: payload }),
    /** @type {BooleanPayloadReducer} */
    DEBUG_MODE: (state, { payload }) => ({ ...state, viewInspector: payload }),
    /** @type {BooleanPayloadReducer} */
    POLLING: (state, { payload }) => ({ ...state, polling: payload }),
    /** @type {StringPayloadReducer} */
    SET_API: (state, { payload }) => ({ ...state, overrideAPI: payload }),
    /** @type {BooleanPayloadReducer} */
    CREATE_SSO_USERS: (state, { payload }) => ({ ...state, create_sso_users: payload }),
    /** @type {BooleanPayloadReducer} */
    RUN_SENTRY_LOCALHOST: (state, { payload }) => ({ ...state, run_sentry_localhost: payload }),
    SYNC_STATE: (state, { payload: newState }) => ({ ...state, ...newState }),
    RESET_STATE: () => ({ ...initialState }),
    /** @type {BooleanPayloadReducer} */
    SET_TEST_API_HEADER: (state, { payload }) => ({ ...state, useTestApiHeader: payload }),
    /** @type {BooleanPayloadReducer} */
    SET_STYLE2PT0: (state, { payload }) => ({ ...state, isStyle2pt0: payload }),
    /** @type {BooleanPayloadReducer} */
    SET_SHOW_REAL_TIME_AUTHS: (state, { payload }) => ({ ...state, showRealTimeAuths: payload }),
    /** @type {BooleanPayloadReducer} */
    SET_SHOW_REV_BOOST_RETRY: (state, { payload }) => ({ ...state, showRevBoost_retry: payload }),
    /** @type {BooleanPayloadReducer} */
    SET_SHOW_CREDENTIAL_MANAGEMENT_NPT: (state, { payload }) => ({ ...state, showCredentialManagement_npt: payload }),
    /** @type {BooleanPayloadReducer} */
    SET_SHOW_REV_BOOST_EXPERIMENTS2: (state, { payload }) => ({ ...state, showRevBoost_Experiments2: payload }),
    /** @type {BooleanPayloadReducer} */
    SET_SHOW_INVOICES_PAGE: (state, { payload }) => ({ ...state, showInvoicesPage: payload }),
    /** @type {BooleanPayloadReducer} */
    SET_SHOW_NEW_SUMMARY_BAR: (state, { payload }) => ({ ...state, showNewSummaryBar: payload })
};

export const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers
});

export const settings = settingsSlice.reducer;
export const {
    PERSIST_SETTINGS,
    DEBUG_MODE,
    POLLING,
    SET_API,
    CREATE_SSO_USERS,
    RUN_SENTRY_LOCALHOST,
    SYNC_STATE,
    RESET_STATE,
    SET_TEST_API_HEADER,
    SET_SHOW_REAL_TIME_AUTHS,
    SET_STYLE2PT0,
    SET_SHOW_REV_BOOST_RETRY,
    SET_SHOW_REV_BOOST_EXPERIMENTS2,
    SET_SHOW_CREDENTIAL_MANAGEMENT_NPT,
    SET_SHOW_INVOICES_PAGE,
    SET_SHOW_NEW_SUMMARY_BAR
} = settingsSlice.actions;

/**
 * @typedef {function(Object, {payload: boolean}): Object} BooleanPayloadReducer
 */

/**
 * @typedef {function(Object, {payload: string}): Object} StringPayloadReducer
 */
